import type { VAxios } from '../../define/axios/Axios';
import {
  AvailableMagicBeanInfoRes,
  GetOrdersRes,
  MagicBeanLogsRes,
  GetOrderInfoRes,
  GetRefundInfoRes,
  GetInvoiceListRes,
  GetInvoiceInfoRes,
} from '../../entities/cc/transactions.entities';
/**
 * 文件上传接口 STS 配置
 */
export const createApi = (defHttp: VAxios) => ({
  // 获取组织可用灵豆信息
  availableMagicBeanInfo: () => {
    return defHttp.get<AvailableMagicBeanInfoRes>({
      url: '/aiad/transactions/mb-overview',
    });
  },

  // 获取订单列表
  getOrders: (params: {
    page?: number;
    pageSize?: number;
    sortField?: string;
    sortOrder?: string;
    status?: string;
  }) => {
    return defHttp.get<GetOrdersRes>({
      url: '/aiad/transactions/orders',
      params,
    });
  },

  // 取消订单
  closeOrder: (params: { tradeNo?: string }) => {
    return defHttp.put({
      url: '/aiad/transactions/orders',
      params,
    });
  },

  // 获取订单详情
  getOrderInfo: (params: { tradeNo?: string }) => {
    return defHttp.get<GetOrderInfoRes>({
      url: `/aiad/transactions/orders/${params.tradeNo}`,
    });
  },

  // 灵豆操作记录列表
  magicBeanLogs: (params: {
    page: number;
    pageSize: number;
    sortField: string;
    sortOrder: string;
    date: string;
    type: string;
  }) => {
    return defHttp.get<MagicBeanLogsRes>({
      url: '/aiad/transactions/mb-logs',
      params,
    });
  },

  // 通过订单号获取交易详情
  getTradeRightByTradeNo: (params: { tradeNo: number }) => {
    return defHttp.get({ url: '/aiad/transactions/trade-right', params });
  },

  // 获取售后详情
  getRefundInfo: (params: { tradeNo: string }) => {
    return defHttp.get<GetRefundInfoRes>({ url: `/aiad/transactions/refunds/${params.tradeNo}` });
  },

  // 灵豆操作记录统计
  magicBeanLogsStat: (params: { ym: string }) => {
    return defHttp.get<GetRefundInfoRes>({ url: `/aiad/transactions/mb-logs-stat`, params });
  },

  // 申请开票
  applyInvoice: (params: {
    address: string;
    bank: string;
    bankAccount: string;
    email?: string;
    invoiceTitleType: string;
    invoiceType: string;
    phoneNumber?: string;
    taxpayerId: string;
    title: string;
    tradeNo?: string;
    tradeNos?: string[];
  }) => {
    return defHttp.put({ url: `/aiad/transactions/invoices`, params });
  },

  // 发票列表
  getInvoiceList: (params: {
    page: number;
    pageSize: number;
    sortField: string;
    sortOrder: string;
    status: string;
  }) => {
    return defHttp.get<GetInvoiceListRes>({ url: `/aiad/transactions/invoices`, params });
  },

  // 发票详情
  getInvoiceInfo: (params: { tradeNo: string }) => {
    return defHttp.get<GetInvoiceInfoRes>({
      url: `/aiad/transactions/invoices/${params.tradeNo}`,
      params,
    });
  },

  // 灵豆成员消耗统计
  magicBeanMemberConsume: (params: {
    sortField?: string;
    sortOrder?: string;
    date?: string;
    type?: string;
    userId?: string;
  }) => {
    return defHttp.get({
      url: `/aiad/transactions/mb-member-consume`,
      params,
    });
  },

  // 灵豆成员消耗统计
  memberLingDouQuota: (params?: { memberName?: string }) => {
    return defHttp.get({
      url: `/aiad/transactions/mb-quota`,
      params,
    });
  },

  // 组织成员配额启用或关闭
  updateMemberLingDouQuotaStatus: (params: { userId: string }) => {
    return defHttp.put({
      url: `/aiad/transactions/mb-quota/switch-member`,
      params,
    });
  },

  // 修改组织成员配额
  updateMemberLingDouQuota: (params: { userId: string; quota: number }) => {
    return defHttp.put({
      url: `/aiad/transactions/mb-quota/update`,
      params,
    });
  },

  // 组织配额启用或关闭
  updateOrgLingDouQuotaStatus: () => {
    return defHttp.put({
      url: `/aiad//transactions/mb-quota/switch`,
    });
  },

  // 查询总的存储容量
  getStorageInfo: () => {
    return defHttp.get({
      url: `/aiad/capacity/limit`,
    });
  },
});
